@if (isUserAuthenticated) {
  <div class="nav-list list-unstyled p-0 m-0">
    <!--desktop-->
    @if (!shareDataService.isMobileMode()) {
      <div class="dropdown pull-right" dropdown>
        <!-- user's details -->
        <button mat-button [matMenuTriggerFor]="userMenu.menu" class="btn">
          <main-header-user-details [user]="usersData"></main-header-user-details>
        </button>
        <!-- /user's details -->
        <!-- dropdown-user-menu -->
        <dropdown-user-menu #userMenu [user]="usersData" [account] = account></dropdown-user-menu>
        <!-- /dropdown-user-menu -->
      </div>
    } @else {
      <!-- user's details -->
      <div libMobileTopAppender
        data-bs-toggle="collapse"
        data-bs-target="#collapseHeaderMenu"
        aria-expanded="false"
        aria-controls="collapseHeaderMenu">
        <main-header-user-details [user]="usersData"></main-header-user-details>
      </div>
      <!-- /user's details -->
      <!-- dropdown-user-menu -->
      <div class="collapse" #collapseHeaderMenu id="collapseHeaderMenu">
        <div class="p-3 bg-white border-top-1 border-bottom-1">
          <dropdown-user-menu (onMenuClick)="sidebarToggle($event, collapseHeaderMenu)" [user]="usersData" [account] = account></dropdown-user-menu>
        </div>
      </div>
      <!-- /dropdown-user-menu -->
    }
    <!-- /desktop-->
    <!--mobile-->
    <!-- /mobile-->
  </div>
} @else {
  <user-login-button></user-login-button>
}
<!-- not-authenticated-options -->
<!-- /not-authenticated-options -->
